import { useEffect, useRef, useState } from "react";
import { useLoginApi } from "@entities/auth/api/login-api";
import { LocalStorageKey } from "@shared/config/local-storage-key";
import { LOGIN_OK } from "@shared/config/constants";
import { useNavigate } from "react-router-dom";

export const useLoginForm = () => {
    const [idText, setIdText] = useState("");
    const [passwordText, setPasswordText] = useState("");
    const passwordInputRef = useRef<HTMLInputElement>(null);
    const { loginApi, loading, error } = useLoginApi();
    const navigate = useNavigate();

    const handleLoginClick = async () => {
        await loginApi(idText, passwordText);
    };

    // 이미 로그인된 상태면 메인으로 이동
    useEffect(() => {
        if (localStorage.getItem(LocalStorageKey.LOGIN_STATE) === LOGIN_OK) {
            navigate("/home/user");
        }
    }, [navigate]);

    return {
        idText,
        setIdText,
        passwordText,
        setPasswordText,
        passwordInputRef,
        handleLoginClick,
        loading,
        error,
    };
};
